import {
  ApiBlueprint,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import {
  ExternalDownDetectorApiClient,
  externalDownDetectorApiRef,
} from './api';

// Unnamed, so its id is `api:external-down-detector`. To stub the API (dev app,
// tests), provide an ApiBlueprint for the same ref from a module with
// `pluginId: 'external-down-detector'`; the same id then replaces this one.
export const externalDownDetectorApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: externalDownDetectorApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new ExternalDownDetectorApiClient(discoveryApi, fetchApi),
    }),
});
